import api from './client';
import { API_BASE_URL } from '@/config';

export interface Insight {
  id: string;
  title: string;
  type: 'Risk' | 'Opportunity' | 'Performance' | 'Trend';
  priority: 'High' | 'Medium' | 'Low';
  status: 'New' | 'Reviewed' | 'Actioned';
  source: 'AI' | 'Rule' | 'Manual';
  scope: 'Project' | 'WBS' | 'Resource' | 'Calendar';
  impact: string;
  description: string;
  recommendation: string;
  confidence?: number;
  finishDelta?: number;
  milestonesAffected?: number;
  activitiesAffected?: number;
  createdAt: string;
}

/**
 * Fetch insights for a project
 */
export const getProjectInsights = async (projectId: string): Promise<Insight[]> => {
  try {
    const response = await api.get(`${API_BASE_URL}/v1/analytics/projects/${projectId}/insights`);
    
    // Map backend response to frontend Insight interface
    const backendInsights = response.data || [];
    return backendInsights.map((insight: any) => ({
      id: insight.id || '',
      title: insight.title || '',
      type: insight.type || 'Risk',
      priority: insight.priority || (insight.severity === 'high' || insight.severity === 'High' ? 'High' : insight.severity === 'medium' || insight.severity === 'Medium' ? 'Medium' : 'Low'),
      status: insight.status || 'New',
      source: insight.source || 'Rule',
      scope: insight.scope || 'Project',
      impact: insight.impact || '',
      description: insight.description || '',
      recommendation: insight.recommendation || '',
      confidence: insight.confidence,
      finishDelta: insight.finishDelta,
      milestonesAffected: insight.milestonesAffected || 0,
      activitiesAffected: insight.activitiesAffected || 0,
      createdAt: insight.createdAt || new Date().toISOString(),
    }));
  } catch (error) {
    console.error('Error fetching project insights:', error);
    throw error;
  }
};

/**
 * Update insight status
 */
export const updateInsightStatus = async (insightId: string, status: 'New' | 'Reviewed' | 'Actioned'): Promise<void> => {
  try {
    await api.patch(`${API_BASE_URL}/v1/analytics/insights/${insightId}/status?status=${encodeURIComponent(status)}`);
  } catch (error) {
    console.error('Error updating insight status:', error);
    throw error;
  }
};




